
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_pdsba_26",
  "button": "awsui_button_vjswe_pdsba_30",
  "variant-normal": "awsui_variant-normal_vjswe_pdsba_82",
  "disabled": "awsui_disabled_vjswe_pdsba_100",
  "variant-primary": "awsui_variant-primary_vjswe_pdsba_107",
  "variant-link": "awsui_variant-link_vjswe_pdsba_132",
  "variant-icon": "awsui_variant-icon_vjswe_pdsba_157",
  "variant-control-group-action": "awsui_variant-control-group-action_vjswe_pdsba_182",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_pdsba_209",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_pdsba_234",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_pdsba_259",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_pdsba_288",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_pdsba_313",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_pdsba_338",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_pdsba_368",
  "button-no-text": "awsui_button-no-text_vjswe_pdsba_481",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_pdsba_485",
  "full-width": "awsui_full-width_vjswe_pdsba_488",
  "button-compact": "awsui_button-compact_vjswe_pdsba_505",
  "grouped-with-error": "awsui_grouped-with-error_vjswe_pdsba_529",
  "grouped-with-warning": "awsui_grouped-with-warning_vjswe_pdsba_529",
  "grouped-disabled": "awsui_grouped-disabled_vjswe_pdsba_529",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_vjswe_pdsba_529",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_vjswe_pdsba_529",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_vjswe_pdsba_529",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_vjswe_pdsba_529",
  "grouped-vertical-first": "awsui_grouped-vertical-first_vjswe_pdsba_532",
  "grouped-vertical-only": "awsui_grouped-vertical-only_vjswe_pdsba_532",
  "grouped-vertical-last": "awsui_grouped-vertical-last_vjswe_pdsba_535",
  "grouped-row-first": "awsui_grouped-row-first_vjswe_pdsba_538",
  "grouped-with-action": "awsui_grouped-with-action_vjswe_pdsba_541",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_vjswe_pdsba_541",
  "icon-left": "awsui_icon-left_vjswe_pdsba_550",
  "icon-right": "awsui_icon-right_vjswe_pdsba_555",
  "icon": "awsui_icon_vjswe_pdsba_550",
  "link": "awsui_link_vjswe_pdsba_574",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_pdsba_574"
};
  